import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  lineStyle: theme => ({
    flex: 1,
    backgroundColor: theme.colors.inActiveDot,
  }),
  visibleLineStyle: {
    height: 1,
  },
  invisibleLineStyle: {
    height: 0,
  },
  redLineStyle: theme => ({
    backgroundColor: theme.colors.activeTabColorTwo,
  }),
})
